import reduxStore from "redux/store";

const saveFormDraft = (id, saveFunc, formId) => {
    const state = reduxStore.getState();
    saveFunc(id, state.formValues[formId]);
}

export default saveFormDraft;